import { GTR } from "../../common/apiUrl/gtr/gtrUrls"
import { DeleteAndArchiveDeliveredGatherJsonRequest } from "../../common/model/gtr/jsonRequest"
import { generateCallbackCurlCommand, generateNoBodyCurlCommand } from "../helperFunctions"


const deleteAndArchiveDeliveredGatherJsonRequest: DeleteAndArchiveDeliveredGatherJsonRequest = {
    gatherId: 0,
    correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    callbackUri: "string",
}

export const deleteDeliveredGatherJsonRequestCurl = generateCallbackCurlCommand(
    GTR.DELIVERED.DELETE_DELIVERED_GTR_URL,
    "DEL",
    deleteAndArchiveDeliveredGatherJsonRequest
)

export const archiveDeliveredGatherJsonRequestCurl = generateCallbackCurlCommand(
    GTR.DELIVERED.ARCHIVE_GTR_URL,
    "PUT",
    deleteAndArchiveDeliveredGatherJsonRequest
)

export const inProcessGatherJsonRequestCurl = generateNoBodyCurlCommand(
    GTR.IN_PROCESS.GET_IN_PROCESS_GTR_URL,
    "GET"
)

export const deleteInProcessGatherJsonRequestCurl = generateCallbackCurlCommand(
    GTR.IN_PROCESS.DELETE_IN_PROCESS_GTR_URL,
    "DEL",
    deleteAndArchiveDeliveredGatherJsonRequest
)
